import React, { createContext } from "react";
import { Policy } from 'cockatiel';

export const RetryPolicyContext = createContext();

export const RetryPolicyProvider = ({ children }) => {
    const retryPolicy = Policy.handleAll() // handle all errors
        .retry() // get a RetryBuilder
        .attempts(3).delay(500); // retry three times

    const executeWithRetry = (fn, ...args) => {
        return retryPolicy.execute(async() => await fn(...args));
    };

    const contextValue = { executeWithRetry };

    return (
        <RetryPolicyContext.Provider value={contextValue}>
        {children}
        </RetryPolicyContext.Provider>
    );
};
